
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import { GetStaticPaths, NextPage } from 'next';
import { useUser } from 'components/hooks/state';
import CourseContentEnrolled from 'pages/course/content/enrolled';
import ItemHeroEnrolled from 'components/atomic/organisms/item-hero/enrolled';
import ItemHero from 'components/atomic/organisms/item-hero';
import MainLayout from 'components/layouts/main-layout';
import CourseContent from 'pages/course/content';
import SEO from 'pages/course/seo';
import devvSdk from 'utils/devv-sdk';
import { Track } from 'types/types';
interface CourseDetailsPageProps {
    course: Track;
}
const CourseDetails: NextPage<CourseDetailsPageProps> = ({ course }) => {
    const { user } = useUser();
    const enrolled = React.useMemo(() => {
        return user?.enrolled_tracks?.includes(course._id);
    }, [user, course._id]);
    return (<>
            <SEO course={course}/>
            <MainLayout isFluid>
                {enrolled ? (<>
                        <ItemHeroEnrolled item={course} itemType={'course'}/>
                        <CourseContentEnrolled course={course}/>
                    </>) : (<>
                        <ItemHero item={course} itemType={'course'}/>
                        <CourseContent course={course}/>
                    </>)}
            </MainLayout>
        </>);
};
export const getStaticPaths: GetStaticPaths = async () => {
    const { data: courses } = await devvSdk.getCoursesOverview();
    return {
        paths: courses.map((course) => ({
            params: { slug: course.slug },
        })),
        fallback: false,
    };
};
const getStaticProps = async ({ params }: {
    params: {
        slug: string;
    };
}) => {
    const { data: course } = await devvSdk.getCourseBySlug(params.slug);
    return {
        props: {
            course,
        },
    };
};
export default CourseDetails;

    async function __Next_Translate__getStaticProps__18916ceb4cb__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/courses/[slug]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18916ceb4cb__ as getStaticProps }
  